import React from 'react'
import Traduction from 'Components/Traduction'
import Select from 'Components/Select'
import Input from 'Components/Input'
import EurestoDiv from '../../../EurestoDiv/index'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'
import Modal from 'Components/Modal'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import fas from 'EurestoFonction/FontAwesomeIcon'
import Switch from 'Components/Switch'

import ApiRequest from 'EurestoApi/ApiRequest'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'

const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      key: Utils.getRandomNumber(),
      actif: User.TypeAccess.get(Constants.access.EURESTO) && 2 || 1,
      action: props.action,
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getFamille()
    }
  }

  getFamille = async () => {
    const result = await ApiRequest(project.api + 'sdd', {
      requete: 'classeur',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        classeur_id: result.results.classeur_id,
        visible: result.results.visible,
        actif: result.results.actif,
        icon: result.results.icon,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      classeur_id: undefined,
      visible: 1,
      actif: undefined,
      icon: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'sdd', {
      requete: 'classeur',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      classeur_id: this.state.classeur_id,
      actif: this.state.actif,
      icon: this.state.icon,
      visible: this.state.visible
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'sdd', {
      requete: 'classeur',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">


        {this.state.sub && <DataComponent
          title={EurestoI18n.t('commun:Classeur')}
          name="classeur_id"
          type={Constants.typeSaisie.ComboSimple}
          onChange={this.onChangeState}
          disabled={disabled}
          data={this.state.classeur_id}
          object={Constants.donnee.classeur}
          module={Constants.module.SDD}
          search={{ classeur_id: null }}/>}

        <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify="center"
              alignItems="center">
          <Grid item style={{ margin: 0, padding: 0 }}>
            <i onClick={() => !disabled && this.setState({
              showModal: !(this.state.showModal || false)
            })} style={{
              padding: 5, fontWeight: 'bold', marginTop: -7,
              boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)', textAlign: 'center'
            }}
               className={'cursor-pointer fa-btn EurestoPrimary--text fa-2x fa fa-' + (this.state.icon || ' ei-sdd_classeur')}/>
          </Grid>
          <Grid item xs style={{ margin: 0, padding: 0 }}>
            <Traduction
              key={autoFocus}
              autoFocus={autoFocus}
              title={EurestoI18n.t('commun:Nom')}
              onChange={this.onChangeState}
              name={'libelle'}
              disabled={disabled}
              data={this.state.libelle !== undefined ? this.state.libelle : []}
              type={Constants.typeSaisie.SaisieLibre}
            />
          </Grid>
        </Grid>
        {User.TypeAccess.get(Constants.access.EURESTO) && <Select
          title={EurestoI18n.t('commun:Accessible pour...')}
          name="actif"
          disabled={disabled}
          options={[
            {
              label: EurestoI18n.t('commun:Tous'),
              value: 1
            },
            {
              label: EurestoI18n.t('commun:Seulement Euresto'),
              value: 2
            },
            {
              label: EurestoI18n.t('commun:Tous sauf Euresto'),
              value: 3
            }
          ]}
          value={this.state.actif !== undefined ? this.state.actif : 1} onChange={this.onChangeState}/>}
        {
          <Switch checked={this.state.visible} name={'visible'}
                  disabled={disabled} onChange={this.onChangeState} title={EurestoI18n.t('commun:Visible')}/>
        }
      </Grid>
    )
  }

  render () {
    return (
      <Grid container>
        <EurestoForm key={this.state.key}
                     {...this.props.formProps}
                     libelle={this.state.defaultLibelle}
                     action={this.state.action}
                     isAllow={this.props.isAllow}
                     onSave={this.onSave}
                     onCancel={this.onCancel}
                     onDelete={this.onDelete}
                     onArchive={this.onArchive}
                     onView={this.onView}
                     libelleAdd={EurestoI18n.t('commun:Nouveau classeur')}
                     children={this.form}/>
        {this.state.showModal &&
        <Modal
          grid={{ xs: 6 }}
          open={this.state.showModal}
          onClose={() => this.handleClickModalIcon(false)}>
          <EurestoDiv
            buttonsRight={[{
              icon: ' ei-commun_fermer',
              className: 'EurestoError--text EurestoText',
              cb: () => this.handleClickModalIcon(false)
            }]}
            style={{
              height: User.CalculHeight.getHeightWanted(70),
              maxHeight: User.CalculHeight.getHeightWanted(70),
              overflow: 'hidden'
            }}
            title={
              <Grid container style={{ margin: 0, padding: 0 }} justify={'center'}
                    alignItems={'center'}>
                <Grid style={{ margin: 0, padding: 0 }} item xs={5}>
                  <Input placeholder={'Rechercher une icône (en anglais)'}
                         onChange={(data) => this.setState({ searchFa: data })} value={this.state.searchFa}
                         style={{ witdh: '30%', backgroundColor: 'white' }}/>
                </Grid>
              </Grid>
            }>
            <Tabs
              style={{ position: 'relative', color: 'black', fontWeight: 'bold' }}
              value={this.state.IconTabSelected || 0}
              onChange={(e, val) => this.setState({ IconTabSelected: val })}
              variant={'fullWidth'}
              className=""
              centered>
              <Tab value={0} label={'Déjà utilisées'}/>
              <Tab value={1} label={'Catalogue'}/>
            </Tabs>
            <div style={{
              height: User.CalculHeight.getHeightWanted(120),
              maxHeight: User.CalculHeight.getHeightWanted(120),
              overflow: 'auto'
            }}>
              <Grid container justify={'flex-start'} alignItems={'flex-start'} style={{ margin: 0, padding: 0, }}
                    spacing={0}>
                {
                  (this.state.IconTabSelected === 0 || this.state.IconTabSelected === undefined) && Array.from(new Set((Data.list(Constants.module.SDD, Constants.donnee.classeur, {
                    icon: {
                      not: true,
                      value: null
                    }
                  }) || []).map(c => c.icon))).filter(fa => this.state.searchFa && fa.indexOf(this.state.searchFa) !== -1 || (this.state.searchFa === undefined || this.state.searchFa === '') && true || false).map(fa => (
                    <Grid item xs={3} style={{ margin: 0, padding: 5 }}>
                      <i onClick={() => this.setState({
                        icon: fa
                      }, () => this.handleClickModalIcon(false))} style={{
                        fontWeight: 'bold',
                        padding: 5,
                        fontSize: 70,
                        width: 100,
                        boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)'
                      }}
                         className={'cursor-pointer fa-btn EurestoPrimary--text fa fa-' + fa}/>
                    </Grid>
                  ))
                }
                {
                  this.state.IconTabSelected === 1 && fas.filter(fa => this.state.searchFa && fa.indexOf(this.state.searchFa) !== -1 || (this.state.searchFa === undefined || this.state.searchFa === '') && true || false).map(fa => (
                    <Grid item xs={3} style={{ margin: 0, padding: 5 }}>
                      <i onClick={() => this.setState({
                        icon: fa
                      }, () => this.handleClickModalIcon(false))} style={{
                        fontWeight: 'bold',
                        padding: 5,
                        fontSize: 70,
                        width: 100,
                        boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)'
                      }}
                         className={'cursor-pointer fa-btn EurestoPrimary--text fa fa-' + fa}/>
                    </Grid>
                  ))
                }
              </Grid>
            </div>
          </EurestoDiv>
        </Modal>}
      </Grid>
    )
  }

  handleClickModalIcon = (open) => {
    this.setState({
      showModal: open
    })
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Messagerie/Classeur.js